import React from "react"
import GenericModal, {Props as ModalProps} from "@irati/ui/src/GenericModal"
import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import {CelebrationTag} from "@irati/types"
import PreviewContent from "./PreviewContent"
interface Props extends ModalProps {
  rewardTemplate?: CelebrationTag
  rewardMessage: string
  rewardTitle: string
  rewardPoints: number
}
const FullPreview = (props: Props) => {
  const templatePreviewProps = {
    rewardMessage: props.rewardMessage,
    rewardPoints: props.rewardPoints,
    rewardTitle: props.rewardTitle,
    rewardTemplate: props.rewardTemplate
  }
  return (
    <GenericModal {...props} hideActions>
      <PreviewContent {...templatePreviewProps} />
      <Button onClick={props.onHide} full primary marginTop={2}>
        <FormattedMessage id="platform.wallet.reward.template.exitPreviewBtn" />
      </Button>
    </GenericModal>
  )
}

export default FullPreview
